Vendd.Scripts.load(function () {
    var $form = $('.x-invoice-access-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        OrderCode: "",
        OrderPhone: ""
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);
        var data = envelope.message.data;

        if (data.success) {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            var url = '/services/api/eInvoice/GetInvoiceDocumentUnauthorized?orderCode=' + formData.orderCode + '&orderPhone=' + formData.orderPhone;

            $('.js-download .download-button').attr("href", url);

            $('.js-download').show();

        } else {
            $('.js-error', $form).show();
        };

    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.InvoiceAccess.Messages.Submit(formData.orderCode,formData.orderPhone));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="orderCode"]', $form).val("");
        $('input[name="orderPhone"]', $form).val("");

        cf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val = cf.validate();

        if (val) {
            form.submit();
        }
    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('keyup', 'input[name]', function (e) {
        if (e.keyCode == 13) {

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    //init validation options
    var validationOptions = {
        orderCode: {
            required: 'ordercode-required'
        },
        orderPhone: {
            required: 'orderphone-required'
        },
    };

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox();
    }

    Vendd.MessageBus.subscribe(Vendd.InvoiceAccess.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.InvoiceAccess.Messages.SubmitFailure, form, form.onFailure);
});

